import { isNil } from 'ramda'
import { isNotNil } from 'ramda-adjunct'
import { useEffect } from 'react'
import { useMutation } from 'urql'

const useMarkResult = (mutation, data, errorReporter) => {
  const [markResultAsReadResult, markResultAsRead] = useMutation(mutation)

  // We can't mark the report as read until the report is available
  const pause =
    isNil(data) ||
    markResultAsReadResult.fetching ||
    markResultAsReadResult.error ||
    markResultAsReadResult.data

  useEffect(() => {
    // We can't mark the report as read if the sleep report is null
    if (!pause && isNotNil(data.currentSleepReport)) {
      markResultAsRead({
        id: data.currentSleepReport.id,
        enrolmentId: data.currentSleepReport.enrolment.id,
      }).catch((error) => {
        errorReporter.send(error, {
          reporterCalledFrom: `useMarkResult`,
        })
      })
    }
  }, [data, errorReporter, markResultAsRead, pause])

  return markResultAsReadResult
}

export default useMarkResult
